import { PageHero, usePageMeta } from "@/components/site/PageHero";
import { WhyUs } from "@/components/site/WhyUs";
import { CtaBand } from "@/components/site/CtaBand";
import { Reveal, Eyebrow } from "@/components/site/Reveal";

const STATS = [
  { v: "3", k: "Eğitim ve tur seçeneği" },
  { v: "2 saat", k: "Rehberli orman turu" },
  { v: "7.000+", k: "Instagram takipçisi" },
  { v: "1", k: "Adres: Çekmeköy / Ömerli" },
];

export default function About() {
  usePageMeta("Hakkımızda", "FX Motor Sporları, Çekmeköy / Ömerli'de kendi parkuru olan motosiklet spor kulübü: eğitim, çocuk eğitimi, enduro tur ve kulüp üyeliği.");
  return (
    <>
      <PageHero eyebrow="Hakkımızda" title="Burada tutku var." intro="FX Motor Sporları — Sancaktepe Motosiklet Spor Kulübü. Çekmeköy Ormanları'nın içinde, enduroyu seven herkesi bir araya getiren kulüp." img="/ig/ig04.jpg" alt="FX kulüp alanında sürücüler ve motosikletler" crumbs={[{ label: "Hakkımızda" }]} />
      <section className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-5 py-24 md:px-8 md:py-32 lg:grid-cols-2">
        <Reveal>
          <Eyebrow>FX Motor Sporları</Eyebrow>
          <h2 className="font-display text-5xl uppercase leading-none text-white md:text-6xl">Parkur, motor, ekip. Hepsi tek yerde.</h2>
          <div className="mt-8 space-y-5 text-base leading-relaxed text-neutral-400 md:text-lg">
            <p>Kendi parkurumuz ve doğası var. Ömerli'de, Çekmeköy Ormanları'nın doğal parkurlarında; ilk kez motora binecek olanı da yılların sürücüsünü de aynı heyecanla karşılıyoruz.</p>
            <p>Motor ve ekipman bizden. Motorun yoksa enduro turla tesise ait motor, ekipman ve kıyafetlerle profesyonel rehberler eşliğinde sürebilirsin.</p>
            <p>Eğitim, çocuk eğitimi, enduro tur ve kulüp üyeliği — hepsi tek kulüpte. Gel, giyin, sür; gerisini biz hallederiz.</p>
          </div>
        </Reveal>
        <Reveal delay={0.1} className="grid grid-cols-2 gap-3">
          <img src="/ig/ig11.jpg" alt="Kırmızı duvara boyanmış FX Motors logosu" className="aspect-[3/4] w-full object-cover" />
          <img src="/ig/ig09.jpg" alt="FX Motors finish garajı" className="mt-12 aspect-[3/4] w-full object-cover" />
        </Reveal>
      </section>
      <section className="border-y border-white/10">
        <div className="mx-auto grid max-w-7xl grid-cols-2 md:grid-cols-4">
          {STATS.map((s, i) => (
            <div key={s.k} data-testid={`about-stat-${i}`} className="border-r border-white/10 px-5 py-12 last:border-r-0 md:px-8">
              <p className="font-display text-6xl leading-none text-brand md:text-7xl">{s.v}</p>
              <p className="mt-3 text-xs uppercase tracking-[0.2em] text-neutral-400">{s.k}</p>
            </div>
          ))}
        </div>
      </section>
      <WhyUs />
      <CtaBand />
    </>
  );
}
